<template>
    <Modal
        id="run-exclusive-acceptance-modal"
        v-model:open="open"
        title="modal_title_run_exclusive_acceptance"
        @cancel="cancel"
        @submit="submit"
    >
        <div>
            <TextField
                v-if="paymentAccountType === 'lemonway'"
                v-model="wallet"
                label="wallet"
                name="wallet_id"
                help="help_transfer_to_project_wallet_wallet"
            />
            <p v-else>
                {{ $t('are_you_sure_you_want_to_run_exclusive_acceptance') }}
            </p>
        </div>

        <!-- Modal footer -->
        <template #actions>
            <button
                :disabled="disableSubmit"
                type="submit"
                class="btn-sm bg-gray-500 text-white"
                :class="{
                    'bg-primary-accent-500 hover:bg-primary-accent-600':
                        !disableSubmit,
                }"
            >
                {{ $t('start_process') }}
            </button>
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { Modal, TextField } from '@src/components'
import { PaymentAccountType } from '@src/enums/PaymentAccount'
import { Platform } from '@src/types'
import { useVModels } from '@vueuse/core'
import { computed, ref } from 'vue'

const props = defineProps<{
    open: boolean
    platform: Platform
    paymentAccountType: PaymentAccountType
}>()

const emit = defineEmits(['update:open', 'cancel', 'submit'])

const { open } = useVModels(props, emit)

const wallet = ref('')

const disableSubmit = computed(() => {
    if (
        props.paymentAccountType === PaymentAccountType.LEMONWAY &&
        !wallet.value
    ) {
        return true
    }
    return false
})

function submit(): void {
    emit('submit', {
        wallet: wallet.value,
    })
    reset()
}

function cancel() {
    emit('cancel')
    reset()
}

function reset() {
    wallet.value = ''
}
</script>
